export default __webpack_public_path__ + "f0a4e3b.png";